/**
 * Conroo REST Frontend Backend
 * REST Interface for new Conroo backend for frontend app communication.
 *
 * OpenAPI spec version: v1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { DepotGetStatusResponseTO } from '../models/DepotGetStatusResponseTO';
import { HttpFile } from '../http/http';

export class DepotGetStatusMultiResponseTO {
    'responses': Array<DepotGetStatusResponseTO>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "responses",
            "baseName": "responses",
            "type": "Array<DepotGetStatusResponseTO>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return DepotGetStatusMultiResponseTO.attributeTypeMap;
    }

    public constructor() {
    }
}

